module.exports = __webpack_public_path__ + "img/productHSE_2.08a692b2.png";